import { inject, Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';
import {
  MedServiceSetHeaderRowItem,
  MedServiceSetHeaderRowItemSearchResult,
  MedServiceSetMetadataUpdateRequest,
  MhsConfigurationApiClient,
} from '../../../core/api/mhsConfigurationApiClient';
import { AuthStore } from '../../../core/authentication/authStore';
import { UsertStore } from '../../../core/context/userStore';

@Injectable({
  providedIn: 'root',
})
export class ProcedureSetsService {
  private readonly configurationApiClient = inject(MhsConfigurationApiClient);
  private readonly authStore = inject(AuthStore);
  private readonly userStore = inject(UsertStore);

  /** Zwraca zestaw procedur po id. */
  getById(id: number): Observable<MedServiceSetHeaderRowItem> {
    if (this.authStore.accessToken() === '') {
      return EMPTY;
    }

    return this.userStore.currentTenant$.pipe(
      filter((tenant) => tenant !== null),
      take(1),
      switchMap(() => this.configurationApiClient.medServiceSets_Get(id)),
    );
  }

  /** Aktualizuje metadane zestawu procedur. */
  updateMetadata(id: number, name: string, defaultEtcInMinutes: string): Observable<void> {
    if (this.authStore.accessToken() === '') {
      return EMPTY;
    }

    return this.userStore.currentTenant$.pipe(
      filter((tenant) => tenant !== null),
      take(1),
      switchMap(() =>
        this.configurationApiClient.medServiceSets_UpdateMetadata(
          id,
          new MedServiceSetMetadataUpdateRequest({
            name,
            defaultEtcInMinutes,
          }),
        ),
      ),
    );
  }

  /** Zwraca stronicowaną listę zestawów procedur. */
  search(
    type?: string,
    phrase?: string,
    isMultiple?: string,
    pageIndex = 1,
    pageSize = 10,
    orderBy?: string,
    isOrderByAsc?: boolean,
  ): Observable<MedServiceSetHeaderRowItemSearchResult> {
    if (this.authStore.accessToken() === '') {
      return EMPTY;
    }

    return this.userStore.currentTenant$.pipe(
      filter((tenant) => tenant !== null),
      take(1),
      switchMap(() =>
        this.configurationApiClient.medServiceSets_Query(
          type,
          phrase,
          isMultiple,
          pageIndex,
          pageSize,
          orderBy,
          isOrderByAsc,
        ),
      ),
    );
  }
}
